'use client';

import { Box, List, Text } from 'pcln-design-system';
import React, { memo } from 'react';
import ContentfulListItem from '../ContentfulListItem';
/** @public */
function ContentfulList({
  heading,
  items,
  ...props
}) {
  return items.length > 0 ? React.createElement(Box, {
    ...props
  }, React.createElement(Text, {
    textStyle: 'heading6',
    mb: 3
  }, heading), React.createElement(List.ul, {
    m: 0,
    p: 0,
    indentSize: 'none'
  }, items.map((item, index) => React.createElement(ContentfulListItem, {
    key: index,
    ...item,
    mb: 2
  })))) : null;
}
export default memo(ContentfulList);